export default __webpack_public_path__ + "static/media/tick.051e2bcc.png";